<template>
  <div v-if="pharmacistType == 1">
    <div class='remind-content'>
      <!-- 待处理消息列表 -->
      <div v-if='reminderStatus'>
        <div class='remind-box' v-on:mouseleave="showList($event)">
          <div v-if='showListContent.length > 0 '>
            <div class="remind-box-item" v-for='(item,index) in showListContent' :key='index' @click='goDetails(item)'>
              患者{{item.memberCardName || item.patientName}}的<span v-if='item.consultationType == null'>处方待审核</span><span
                v-else-if='item.consultationType == 5'>订单待发货</span>
            </div>
          </div>
          <div v-else class='no-data'>
            暂无更多数据
          </div>
        </div>
        <!-- 底部箭头 -->
        <i class='el-icon-arrow-down gray'></i>
      </div>
      <!-- 红点 -->
      <div class='remind-red' v-if='ballStatus'></div>
      <!-- 铃铛图片 -->
      <img src="../../../assets/images/bells.png" class='remind-icon' alt="" v-on:mouseover="showList($event)" v-on:mouseout="reminderStatus = false">
      <i class="el-icon-s-tools remind_setting" @click="dialogVisible = true"></i>
    </div>

    <el-dialog title="铃铛播报设置" :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false">
      <el-form :model="paramsRemind" ref="receiverInfoForm" label-width="auto">
        <el-form-item label="播报时间间隔">
          <el-select v-model="paramsRemind.broadcast" placeholder="请选择播报时间间隔">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        </el-form-item>

        <el-form-item label="暂缓播报时间间隔">
          <el-input v-model="paramsRemind.suspension" oninput="value=this.value.replace(/[^\d]/g, '')" size="mini" style="width: 60px"></el-input> 分钟
        </el-form-item>
        <el-form-item label="播报开关">
          <el-radio v-model="paramsRemind.switchFlag" label="1">开启播报</el-radio>
          <el-radio v-model="paramsRemind.switchFlag" label="0">暂停播报</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="sureDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import {
    getRemindInfo,
    personalPharmacist,
    updatePharmacist
  } from "@/api/order";
  export default {
    data() {
      return {
        remindList: [], //  待播放提醒列表
        showListContent: [], //  显示的列表
        remindListAfter: [], // 播放完后的列表
        ballStatus: false, // 铃铛红色提示小球,
        reminderStatus: false, // 待审核列表显示状态
        playText: '', // 播放的声音文字
        timeStamp: Date.parse(new Date()), // 当前打开页面调取的时间戳
        quyerTime: 40000, // 调取接口延时时间
        remindListAfterMap: {},
        voiceFlag: true,
        pharmacistType: 1,
        dialogVisible:false,
        remind: {
          switchFlag:"1",
          suspension:null, // 暂缓播报时间间隔
          broadcast:null // 播报时间间隔
        },
        paramsRemind: {
          switchFlag:"1",
          suspension:null, // 暂缓播报时间间隔
          broadcast:null // 播报时间间隔
        },
        duration: 0,
        waitTime: 0,
        options: [],
        timer: null,
        durationer: null,
        suspensioner: null,
      }
    },
    inject: ['reload'],
    created() {
      const that = this;
      that.pharmacistType = localStorage.getItem("pharmacistType");
      if(!!localStorage.getItem("pharmacistType") && localStorage.getItem("pharmacistType") == 2) {
        // 医院药师直接返回
        return;
      }
      let time = 240
      while(time) {
        this.options.unshift({
          value: time,
          label: `${time}分钟`
        })
        time = time - 5
      }
      // 初始化数据
      that.getRemindInfo(true);
      this.personalPharmacist();
    },
    
    methods: {
      // 拿到数据 轮巡比较
      getRemindInfo(isOnCreated) {
        let that = this;
        let obj = {};
        getRemindInfo(obj).then(response => {
          if (response.code == 200) {
            let data = response.data; // 拿到的全部数据
            that.remindList = data.prescriptionAndDrugList;
            that.showListContent = JSON.parse(JSON.stringify(data.prescriptionAndDrugList));
            that.showListContent.length > 0 ? that.ballStatus = true : that.ballStatus = false;
            // 判断是否初始化
            if (that.remindList != [] && that.remindList.length > 0 && !isOnCreated) {
              // let auditList = []
              // let shipList = []
              // for (let i = 0; i < that.remindList.length; i++) {
              //   if(that.remindList[i].consultationType == 5){ // 待审核
              //     auditList.push(that.remindList[i])
              //   }else{ // 待发货
              //     shipList.push(that.remindList[i])
              //   }
              // }
              // 播报语音
              let browserUrl = window.location.href
              if(browserUrl.indexOf("192.0.0.220:8088") != -1) {
                let url = `/static/net_audio/audio${that.remindList.length}.mp3`
                if(that.remindList.length > 10) {
                  url = `/static/net_audio/audiomore.mp3`
                }
                
                let audio = new Audio(url)
                audio.autoplay = true
                audio.play() // 播放音频对象
                // this.playVoice(url)
              } else {
                let playText = that.switchText(that.remindList.length);
                that.voiceFlag = false;
                console.log("remindWaitTime3", playText)
                let msg = new SpeechSynthesisUtterance(playText);
                msg.lang = 'zh-CN'
                msg.volume = 1
                msg.rate = 1
                msg.pitch = 1
                msg.voice = this.getWindowVoice()
                speechSynthesis.cancel()
                speechSynthesis.speak(msg);
              }
              }
          }
        });
      },

      playVoice(mUrl) {
        let contextClass = window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.msAudioContext;
        try {
          var context = new contextClass();
          var source = null;
          var audioBuffer = null;
          function playSound() {
            source = context.createBufferSource();
            source.buffer = audioBuffer;
            // source.loop = true;
            source.connect(context.destination);
            source.start(0); //立即播放    
          }
          function initSound(arrayBuffer) {
            context.decodeAudioData(arrayBuffer, function (buffer) { //解码成功时的回调函数
              audioBuffer = buffer;
              playSound();
            }, function (e) { //解码出错时的回调函数
              console.log('404', e);
            });
          }
          function loadAudioFile(url) {
            var xhr = new XMLHttpRequest(); //通过XHR下载音频文件
            xhr.open('GET', url, true);
            xhr.responseType = 'arraybuffer';
            xhr.onload = function (e) { //下载完成
              initSound(this.response);
            };
            xhr.send();
          }
          //这里用来存储背景音乐的路径
          loadAudioFile(mUrl);
        } catch (e) {
          console.log('无法找到音乐！');
        }
      },

      getWindowVoice() {
        return window.speechSynthesis.getVoices().find(item => item.localService && item.lang == 'zh-CN')
      },

      personalPharmacist() {
        personalPharmacist({}).then(response => {
          console.log(response.data.broadcast)
          let broadcast = response.data.broadcast
          // broadcast = 0.1

          let remindTemp = localStorage.getItem("remindTime")
          if(remindTemp) {
            remindTemp = JSON.parse(remindTemp)
            remindTemp.broadcast = broadcast
            this.remind = remindTemp
            localStorage.setItem("remindTime", JSON.stringify(remindTemp))
          } else {
            this.remind.broadcast = broadcast
            localStorage.setItem("remindTime", JSON.stringify(this.remind))
          }
          if(!this.oldRemind) {
            this.oldRemind = JSON.parse(JSON.stringify(this.remind))
          }
          this.paramsRemind = JSON.parse(JSON.stringify(this.remind))
          this.cancelCallTime()
        })
      },

      callVoice() {
        let that = this
        if(that.timer) {
          clearInterval(that.timer)
          that.timer = null
        }
        that.timer = setInterval(function () {
          // console.log("remindWaitTime2", that.voiceFlag, parseInt(that.remind.switchFlag) == 1, !that.remind.suspension)
          if (parseInt(that.remind.switchFlag) == 1 && !that.remind.suspension) {
            that.getRemindInfo(false);
          }
          that.cancelCallTime()
        }, this.waitTime)
        if(that.duration) {
          that.durationer = setInterval(() => {
            that.duration = this.duration - 1000
            if(that.duration <= 0) {
              clearInterval(that.durationer)
              that.duration = 0
              that.durationer = null
            }
          }, 1000)
        }
      },

      cancelCallTime() {
        let that = this
        // this.remind
        //  broadcast switchFlag
        // 5min -> 10min  已等待4min 此时再等待6min播报
        // 10min -> 5min  已等待4min 此时再等待1min播报
        // 10min -> 5min  已等待6min/5min 此时立即播报
        let oldRemind = this.oldRemind 
        let remind = this.remind 
        let remindWaitTime = 0
        let tempWaitTime = parseInt(((this.waitTime - this.duration) / 1000 / 60) || 0)   //已经等待了多长时间
        if(remind.broadcast > oldRemind.broadcast) {
          remindWaitTime = remind.broadcast * 60 * 1000 - tempWaitTime * 60 * 1000
        } else if(remind.broadcast == oldRemind.broadcast) {
          remindWaitTime = remind.broadcast * 60 * 1000
        } else {
          if(tempWaitTime < remind.broadcast) {
            remindWaitTime = remind.broadcast * 60 * 1000 - tempWaitTime * 60 * 1000
          } else {
            remindWaitTime = 0
          }
        }

        if(this.remind.suspensionRemind && !that.suspensioner) {
          that.suspensioner = setInterval(() => {
            let temp = JSON.parse(localStorage.getItem("remindTime"))
            temp.suspensionRemind = temp.suspensionRemind - 1000
            if(temp.suspensionRemind <= 1000) {
              clearInterval(that.suspensioner)
              that.suspensioner = null
              this.remind.suspension = ''
              this.remind.suspensionRemind = ''
              localStorage.setItem("remindTime", JSON.stringify(this.remind))
            } else {
              localStorage.setItem("remindTime", JSON.stringify(temp))
            }
          }, 1000)
        }

        console.log("remindWaitTime",oldRemind.broadcast, remind.broadcast, tempWaitTime, remindWaitTime)
        if(oldRemind.broadcast != remind.broadcast) {
          this.oldRemind = JSON.parse(JSON.stringify(this.remind))
        }

        this.waitTime = remindWaitTime
        this.duration = remindWaitTime
        this.callVoice()
      },

      sureDialog() {
        let that = this
        this.dialogVisible = false
        localStorage.setItem("remindTime", JSON.stringify({
          ...this.paramsRemind,
          suspensionRemind: this.paramsRemind.suspension * 60 * 1000
        }))
        this.oldRemind = JSON.parse(JSON.stringify(this.remind))
        if(that.timer) {
          clearInterval(that.timer)
          that.timer = null
        }
        if(that.durationer) {
          clearInterval(that.durationer)
          that.durationer = null
        }
        updatePharmacist({
          broadcast: this.paramsRemind.broadcast
        }).then((res) => {
          this.personalPharmacist();
        })
      },

      cancelDialog() {
        this.dialogVisible = false
        this.paramsRemind = JSON.parse(JSON.stringify(this.remind))
      },

      goDetails(item) {
        const that = this;
        if (item.consultationType == 5) {
          that.$router.push({
            path: "/oms/orderDetail",
            query: {
              id: item.patientPrescriptionDrugsOrderId
            }
          });
        } else {
          that.$router.push({
            path: "/approval/approvalInfo",
            query: {
              patientPrescriptionOrderId: item.patientPrescriptionOrderId
            },
          });
        }
        that.reload.reload();
      },

      // 鼠标经过显示列表 鼠标移除隐藏列表
      showList(e) {
        this.reminderStatus == false ? this.reminderStatus = true : this.reminderStatus = false
      },

      // 提醒文字
      switchText(num) {
        return `来了${num}个待处理订单，请及时处理`
      },

      //  订单时间转为时间戳
      // switchTime(item) {
      //   // 4 待审核  5 代发货
      //   switch (item.consultationType) {
      //     case 4:
      //       // 时间校验 prescriptionDate
      //       const prescriptionDate = new Date(item.prescriptionDate).getTime();
      //       return prescriptionDate;
      //       break;
      //     case 5:
      //       // 时间校验 payTime
      //       const payTime = new Date(item.payTime).getTime();
      //       return payTime;
      //       break;
      //   }
      // },

    },

  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .remind-content {
    position: fixed;
    right: 80px;
    bottom: 50px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #fff;
    border: 1px solid #b7b7b7;
    box-shadow: 4px 5px 20px -5px;
    display: flex;
    align-items: center;
    z-index: 999;
    cursor: pointer;
  }

  .remind-icon {
    width: 22px;
    height: 22px;
    margin: 0 auto;
  }

  .remind_setting {
    width: 22px;
    height: 22px;
    position: absolute;
    right: -7px;
    bottom: -7px;
  }

  .remind-red {
    width: 10px;
    height: 10px;
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 50%;
    background-color: #d9001b;
  }

  //  提醒列表
  .remind-box {
    position: fixed;
    right: 42px;
    bottom: 112px;
    width: 178px;
    padding: 10px;
    border: 1px solid #b7b7b7;
    border-radius: 5px;
    background-color: #fff;
    font-size: 14px;
    max-height: 500px;
    overflow: auto;
  }

  .remind-box-item {
    margin: 5px 0;
    cursor: pointer;
  }

  .gray {
    color: #b7b7b7;
    position: fixed;
    right: 95px;
    bottom: 99px;
    font-size: 20px;

  }

  .no-data {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/remind.vue